// Plain Pinata upload client (no React hooks)
const PINATA_JWT = process.env.REACT_APP_PINATA_JWT || '';
const PINATA_API_KEY = process.env.REACT_APP_PINATA_API_KEY || '';
const PINATA_SECRET_API_KEY = process.env.REACT_APP_PINATA_SECRET_API_KEY || '';

export async function uploadFileToPinata(file, institution, ocrData = null) {
  const formData = new FormData();
  formData.append('file', file, file?.name || 'certificate');

  const sanitizedInstitution = institution.replace(/[^a-zA-Z0-9\s]/g, '').replace(/\s+/g, '_');

  const keyvalues = {
    institution: institution,
    folder: sanitizedInstitution,
    category: "academic_certificate",
    state: "Jharkhand",
    uploadDate: new Date().toISOString().split('T')[0]
  };

  if (ocrData) {
    if (ocrData.studentName && ocrData.studentName.trim()) keyvalues.studentName = ocrData.studentName.trim().substring(0, 50);
    if (ocrData.rollNumber && ocrData.rollNumber.trim()) keyvalues.rollNumber = ocrData.rollNumber.trim().substring(0, 20);
    if (ocrData.certificateType && ocrData.certificateType.trim()) keyvalues.certType = ocrData.certificateType.trim().substring(0, 30);
    if (ocrData.marks && ocrData.marks.trim()) keyvalues.marks = ocrData.marks.trim().substring(0, 15);
  }

  const pinataMetadata = JSON.stringify({ name: `${sanitizedInstitution}/${file.name}`, keyvalues });
  formData.append('pinataMetadata', pinataMetadata);
  formData.append('pinataOptions', JSON.stringify({ cidVersion: 0 }));

  const headers = PINATA_JWT ? { 'Authorization': `Bearer ${PINATA_JWT}` } : {
    'pinata_api_key': PINATA_API_KEY,
    'pinata_secret_api_key': PINATA_SECRET_API_KEY,
  };

  const response = await fetch("https://api.pinata.cloud/pinning/pinFileToIPFS", {
    method: 'POST',
    headers,
    body: formData,
  });

  if (!response.ok) {
    let detail = '';
    try { detail = JSON.stringify(await response.json()); } catch { detail = await response.text().catch(() => ''); }
    throw new Error(`Upload failed: ${response.status} ${response.statusText} - ${detail}`);
  }

  return await response.json();
}


